module.exports = __webpack_public_path__ + "img/Bear43.4d1ad528.jpg";